module.exports = __webpack_public_path__ + "img/business-2.c344d34e.png";